// extracted by mini-css-extract-plugin
export default {"alert":"AuthAlert_alert__LCQ41","success":"AuthAlert_success__-L5IP","error":"AuthAlert_error__mdTJo"};